export const buildDealers = (dealers = [], companies) =>
    dealers.map(dealer => buildDealer(dealer, companies));

const buildDealer = (dealer, companies) => ({
    ...dealer,
    companies: (dealer.projects || [])
        .map(project => companies.find(company => company.crm_area.identifier === project))
        .filter(Boolean)
});
